<template>
    <div class="section">
        <div class="section_slide-three five-g"> 
            <div class="h-100">
                <VueSlickCarousel v-bind="sliderSettings" ref="carousel2">
            
                <!-- another scetion slides  -->
                <div class="slide" v-for="slide in fiveG.slides" :key="slide">
                    <div class="container h-100">
                        <div class="row h-100 align-center align-content-center col-gap-60">
                            <div class="col-lg-7">
                                <div class="infra-boxes">
                                    <div class="row col-gap-50">
                                        <div class="col-sm-6" v-for="box in slide.blocks" :key="box">
                                            <div class="box" data-aos="fade-up">
                                                <p>{{box}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <h4 data-aos="fade-down">{{slide.title}}</h4>
                                <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                        <div class="scroll_pading">
                                            <div class="desc" data-aos="fade-up" >
                                                <p v-for="desc in slide.desc" :key="desc">{{desc}}</p>
                                            </div>
                                        </div>
                                    </scrollbar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <!-- another scetion slides  -->
                </VueSlickCarousel>
                <div class="slider__nav">
                    <button @click.prevent="$refs.carousel2.prev();" class="slider__nav--previous">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 64.806">
                            <use xlink:href="#glanceArrowleft"></use>
                        </svg>
                    </button>
                    <button @click.prevent="$refs.carousel2.next();" class="slider__nav--next">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 64.806">
                            <use xlink:href="#glanceNext"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
export default {
    props:{
        sliderSettings: Object,
        scrollSettings: Object,
        fiveG:Object
    },
    components:{
        VueSlickCarousel,
    }
}
</script>

<style>

</style>